import React, { useContext } from "react"
import styled from "styled-components"
import BackgroundImage from "gatsby-background-image"
import { useStaticQuery, graphql } from "gatsby"
import Breakpoints from "../shared/breakpoints"
import Grid from "../shared/grid"
import { T, FontFamilyRegular } from "../shared/typography.styles"
import { UIContext } from "../shared/layout"

const Container = styled(BackgroundImage)`
  padding: 0 0 48px;

  @media (min-width: ${Breakpoints.md}) {
    padding: 64px 0;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 96px 0;
  }
`

const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column: 2 / -2;
  justify-items: center;

  @media (min-width: ${Breakpoints.md}) {
    grid-template-columns: 7fr 3fr;
    grid-column-gap: 20px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column-gap: 32px;
  }
`

const UnitText = styled.span`
  line-height: 0;
  font-size: 32px;
  margin-left: 4px;
`
const PlusText = styled(UnitText)`
  @media (min-width: ${Breakpoints.md}) {
    font-size: 40px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    font-size: 64px;
  }
`

const SquareFootageText = styled.p`
  ${FontFamilyRegular}
  color: var(--burnt-orange);
  font-weight: 500;
  font-size: 64px;
  line-height: 170%;
  letter-spacing: -0.04em;
  margin-top: 24px;

  @media (min-width: ${Breakpoints.md}) {
    font-size: 60px;
    justify-self: right;
    margin-top: 0;
  }

  @media (min-width: ${Breakpoints.lg}) {
    font-size: 96px;
  }
`

const VenueText = styled(SquareFootageText)`
  display: flex;
  align-items: center;
`

const DescriptionText = styled.p`
  ${FontFamilyRegular}
  font-weight: 500;
  font-size: 16px;
  line-height: 130%;
  text-align: center;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--tricorn-black);
  margin-top: -8px;

  @media (min-width: ${Breakpoints.md}) {
    justify-self: left;
    align-self: center;
    text-align: left;
    font-size: 11px;
    line-height: 120%;
    max-width: 160px;
    margin: 0;
  }

  @media (min-width: ${Breakpoints.lg}) {
    font-size: 18px;
    max-width: 265px;
  }
`

export default function StatsSection(props) {
  const query = useStaticQuery(graphql`
    query {
      lg: file(
        relativePath: {
          eq: "3_RESOURCES/Partner Program/01_desktop/map_background.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      md: file(
        relativePath: {
          eq: "3_RESOURCES/Partner Program/02_tablet/map background tablet.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      sm: file(
        relativePath: {
          eq: "3_RESOURCES/Partner Program/03_mobile/map background mobile.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const backgroundSources = [
    query.sm.childImageSharp.fluid,
    {
      ...query.md.childImageSharp.fluid,
      media: `(min-width: ${Breakpoints.md})`,
    },
    {
      ...query.lg.childImageSharp.fluid,
      media: `(min-width: ${Breakpoints.lg})`,
    },
  ]

  const {
    state: { breakpoint },
  } = useContext(UIContext)

  return (
    <Container fluid={backgroundSources}>
      <Grid>
        <ContentContainer>
          <SquareFootageText>
            {breakpoint === "sm" ? (
              <>
                755<UnitText>M</UnitText>
              </>
            ) : (
              "755,000,000"
            )}
          </SquareFootageText>
          <DescriptionText>
            Square feet mapped in over 40 countries
          </DescriptionText>
          <VenueText>
            1,100<PlusText>+</PlusText>
          </VenueText>
          <DescriptionText>Live venues</DescriptionText>
        </ContentContainer>
      </Grid>
    </Container>
  )
}
